// Check if user is admin based on user object from auth context
export const isAdminUser = (user: { id: string; username: string; isAdmin?: boolean } | null): boolean => {
  return user?.isAdmin === true;
};